import React from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { appDocumentTitle } from '../../appMeta';
import { useAuth } from '../../auth/AuthContext';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { PageShell } from '../../layout/PageShell';
import { useNavigationMenuQuery } from '../../query/hooks';
import { HasilUjiLetterListTabScreen } from './TabScreens/List';

export function HasilUjiLetterPage() {
  const { jwt } = useAuth();
  const menuQ = useNavigationMenuQuery(jwt);
  const canView = menuQ.data?.access_codes?.includes('can_view_hasil_uji_letter') ?? false;

  useDocumentTitle(appDocumentTitle('Hasil Uji Analis'));

  if (menuQ.isPending) {
    return (
      <Box display="flex" justifyContent="center" py={4}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (menuQ.isError) {
    return (
      <Alert severity="error">
        {menuQ.error instanceof Error ? menuQ.error.message : 'Gagal memuat menu permission.'}
      </Alert>
    );
  }

  if (!canView) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <PageShell
      title="Hasil Uji Analis"
      subtitle="Review SPV lab / SPV Admin Sampling / SPV Admin LHU / Manajer Teknis / Customer Service sesuai status pengujian."
    >
      <HasilUjiLetterListTabScreen />
    </PageShell>
  );
}
